import React, { useEffect, useState } from 'react';
import { Select, Spin, message } from 'antd';
import debounce from 'lodash/debounce';
import axios from 'axios';
import { Avatar } from '@mui/material';
import { apiGetAllCustomer } from '@services/ManageCustomers/CustomerServices';

const { Option } = Select;

const CustomerSelect = ({ onChange, initValue, disabled, onDefaultSet, status = undefined }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerSelected, setCustomerSelected] = useState(null);

  const fetchCustomers = async (searchText) => {
    setLoading(true);
    try {
      const response = await apiGetAllCustomer({
        keyWord: searchText ?? undefined,
        page: 1,
        size: 200,
        status: status ?? undefined
      });
      const customerData = response.data?.data || [];
      setCustomers(customerData);

      // Set default to first customer if not already set and onDefaultSet callback exists
      if (customerData.length > 0 && !customerSelected && !initValue && onDefaultSet) {
        const firstCustomer = customerData[0];
        const defaultValue = {
          value: firstCustomer.code,
          label: `${firstCustomer.code} - ${firstCustomer.name}`,
          code: firstCustomer.code
        };
        setCustomerSelected(defaultValue);
        onDefaultSet(firstCustomer.code, defaultValue);
      }
    } catch (error) {
      message.error('Có lỗi khi lấy thông tin khách hàng!');
      console.error('Failed to fetch customers', error);
    }
    setLoading(false);
  };

  const handleSearch = debounce((value) => {
    if (value) {
      fetchCustomers(value);
    } else {
      setCustomers([]);
    }
  }, 300);

  const handleChange = (value, option) => {
    setCustomerSelected(value);
    onChange && onChange(value, { ...option, code: value.value });
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    if (initValue && customers.length > 0) {
      const customerFound = customers.find((customer) => customer.code === initValue);
      if (customerFound) {
        setCustomerSelected({
          value: customerFound.code,
          label: `${customerFound.code} - ${customerFound.name}`
        });
      }
    }
  }, [initValue, customers]);

  const renderCustomerOption = (customer) => (
    <Option key={customer.code} value={customer.code} label={`${customer.code} - ${customer.name}`}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          alt={customer?.name?.toUpperCase()}
          src={customer.avatar ? customer?.avatar : 'https://'}
          sx={{ bgcolor: '#00904A' }}
          style={{ marginRight: 8 }}
        />
        <div>
          <div style={{ fontSize: '14px', fontWeight: '400', color: '#0051A9' }}>
            {`${customer.code} - ${customer.name}`}
          </div>
          <div style={{ fontSize: '12px', color: '#626D7C', fontWeight: '400' }}>
            {customer.address}
          </div>
        </div>
      </div>
    </Option>
  );

  return (
    <Select
      disabled={disabled}
      showSearch
      labelInValue
      placeholder="Lựa chọn khách hàng"
      onChange={handleChange}
      value={customerSelected}
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onSearch={handleSearch}
      style={{ width: '100%', height: '36px' }}
      optionLabelProp="label">
      {customers.map(renderCustomerOption)}
    </Select>
  );
};

export default CustomerSelect;
